const CrownIcon = () => (
  <svg viewBox='0 0 24 24' className='h-[22px] w-[22px]' aria-hidden>
    <circle
      cx='12'
      cy='12'
      r='9'
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
    />
    <path
      d='M8 13l2.5 2.5L16 10'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default CrownIcon;
